import { render, staticRenderFns } from "./channelDetails.vue?vue&type=template&id=5ad7080e&scoped=true&"
import script from "./channelDetails.vue?vue&type=script&lang=js&"
export * from "./channelDetails.vue?vue&type=script&lang=js&"
import style0 from "./channelDetails.vue?vue&type=style&index=0&id=5ad7080e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad7080e",
  null
  
)

export default component.exports